export default function handleTrackingDropdown(id) {
        /* Kept for backwards compatibility, should be deleted once these categories
         * has a tag of their own */
        let cta;
        switch (id) {
        case 5:
                cta = 'super_level_football_boots';
                break;
        case 13:
                cta = 'super_level_football_shirts';
                break;
        case 48:
                cta = 'super_level_equipment';
                break;
        case 551:
                cta = 'super_level_sale';
                break;
        default:
                cta = '';
        }

        return cta;
}
